/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_1_DInputs */

const en_tut_part_1_d = /** @type {(inputs: Tut_Part_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four chapters that take you from the sign-in page to a workspace with people in it.`)
};

const id_tut_part_1_d = /** @type {(inputs: Tut_Part_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat bab yang membawa Anda dari halaman masuk sampai punya ruang kerja berisi orang.`)
};

/**
* | output |
* | --- |
* | "Four chapters that take you from the sign-in page to a workspace with people in it." |
*
* @param {Tut_Part_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_1_d = /** @type {((inputs?: Tut_Part_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_1_d(inputs)
	return en_tut_part_1_d(inputs)
});